import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  display: flex;
  border-radius: var(--radius-brand);
  border: 1px solid var(--border-secondary);
  background: var(--bg-primary);
  padding: var(--space-400) var(--space-500);
  flex-direction: column;
  align-items: flex-start;
  gap: var(--space-500);
  position: relative;
`

export const Content = styled.div`
  width: 100%;
  flex: 1;
  min-height: 264px;
`

export const EmptyMessage = styled.div`
  position: absolute;
  left: 0;
  top: var(--space-300);
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--text-secondary);
  font-size: var(--font-size-300);
  font-style: normal;
  font-weight: var(--font-weight-regular);
  line-height: var(--font-line-height-300); /* 142.857% */
  letter-spacing: var(--font-letter-spacing-loose);
  z-index: 0;
`

export const EmptySpace = styled.div`
  height: 336px;
`
